import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BannerOneComponent } from './banner-one.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [BannerOneComponent],
  exports: [BannerOneComponent],
  imports: [CommonModule, RouterModule],
})
export class BannerOneModule {}
